import ButtonLargeMixin from './mixins/button-large-mixin.js';
import ButtonOutlinedLightMixin from './mixins/button-outlined-light-mixin.js';
import TpButton from './tp-button.js';

class TpButtonOutlinedLightLarge extends
  ButtonLargeMixin(
  ButtonOutlinedLightMixin(
    TpButton
  )) {}

export default TpButtonOutlinedLightLarge;


